var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, buildItemRow;
  init = function (options) {

  };
  loadCart = function () {
    console.log('added');
    $.getJSON('/cart.js', function(cart) {
      buildItemRow(cart);
    });
    // $('.cart-drawer').load(document.URL +  ' .cart-drawer-inner');
    // location.reload();
  };

  buildItemRow = function(cart_obj) {
		var cart_line_item = cart_obj['items'];
		console.log(cart_obj);
		$('.cart-drawer .total-cart').text(cart_obj.item_count)
		$('.cart-toggle .cart-item-count').text(cart_obj.item_count);
		
		// Update subtotal
		var subtotalPrice = parseFloat(cart_obj.items_subtotal_price / 100);
		$('.checkout-box .subtotal-amount').text('$'+subtotalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
		
		// Calculate savings using TRUE original price (handles all discount types)
		var totalSavings = 0;
		var totalOriginalPrice = 0;
		cart_line_item.forEach(function(item) {
			// Determine TRUE original price (before all discounts)
			var trueOriginalPrice;
			if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
				// Has subscription - use selling_plan's compare_at_price as the true original
				trueOriginalPrice = item.selling_plan_allocation.compare_at_price * item.quantity;
			} else if (item.compare_at_price) {
				// Has product-level discount - use compare_at_price
				trueOriginalPrice = item.compare_at_price * item.quantity;
			} else {
				// No product discount - use original_price
				trueOriginalPrice = item.original_price * item.quantity;
			}
			
			var itemFinalPrice = item.final_line_price; // in cents
			var itemSavings = trueOriginalPrice - itemFinalPrice;
			
			totalOriginalPrice += trueOriginalPrice;
			
			if (itemSavings > 0) {
				totalSavings += itemSavings;
			}
		});
		
		// Convert from cents to dollars
		totalSavings = totalSavings / 100;
		totalOriginalPrice = totalOriginalPrice / 100;
		
		if (totalSavings > 0.01) {
			$('.checkout-box .savings-amount').text('$'+totalSavings.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
			$('.checkout-box .cart-savings').attr('style', 'display: flex !important').show();
			
			// Update original price in subtotal
			$('.checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price')
				.text('$' + totalOriginalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))
				.attr('style', 'display: inline !important')
				.show();
		} else {
			$('.checkout-box .cart-savings').attr('style', 'display: none !important');
			$('.checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price').attr('style', 'display: none !important');
		}
		cart_line_item.forEach(function(item_obj) {
			var itemRow = $('.cart-drawer .cart-items .drawer-row-item[data-productid="'+item_obj.id+'"]');
			if (itemRow.length > 0) {
				itemRow.find('.quantity-wrapper input').val(item_obj.quantity);
				var itemPrice = parseFloat(item_obj.line_price / 100);
				itemRow.find('.item-total').text('$'+itemPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
				
				// Determine TRUE original price (before all discounts)
				var trueOriginalPrice;
				if (item_obj.selling_plan_allocation && item_obj.selling_plan_allocation.compare_at_price) {
					// Has subscription - use selling_plan's compare_at_price as the true original
					trueOriginalPrice = item_obj.selling_plan_allocation.compare_at_price * item_obj.quantity;
				} else if (item_obj.compare_at_price) {
					// Has product-level discount - use compare_at_price
					trueOriginalPrice = item_obj.compare_at_price * item_obj.quantity;
				} else {
					// No visible discount - use original_price
					trueOriginalPrice = item_obj.original_price * item_obj.quantity;
				}
				
				var originalLinePrice = trueOriginalPrice / 100; // in dollars
				var finalLinePrice = item_obj.final_line_price / 100; // in dollars
				
				if (originalLinePrice > finalLinePrice + 0.01) {
					// Has discount (product discount or promo code or both)
					var originalPriceFormatted = '$' + originalLinePrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
					var undiscountedEl = itemRow.find('.undiscounte-price');
					if (undiscountedEl.length) {
						undiscountedEl.text(originalPriceFormatted).removeClass('d-none').show();
					} else {
						itemRow.find('.item-total').after(' <span class="undiscounte-price">' + originalPriceFormatted + '</span>');
					}
				} else {
					// No discount
					itemRow.find('.undiscounte-price').addClass('d-none').hide();
				}
			} else {
				var itemRowHtml = '';
				var itemPrice =  parseFloat(item_obj.line_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
				itemRowHtml += `<div class="drawer-row-item" data-productid="${item_obj.id}" data-price="${item_obj.price}" data-lineitem-key="${item_obj.key}">								
													<div class="row no-gutters">
														<div class="col-4 cart-item--thumb">
																<div class="grid-item grid-thumb">
																		<div class="product-thumbnail">
																				<div class="product-image align-middle">
																						<a href="${item_obj.url}">
																							<canvas width="114" height="125" style="background-image: url(${item_obj.featured_image.url.replace(/(\.[^\.]+)$/, '_120x$1')})" class="canvas-image heightbase"></canvas>
																						</a>
																				</div>
																		</div>
																</div>
														</div>
														<div class="col-8 cart-item--description">
															<div class="grid-item grid-desc grid-x">
																	<div class="product-details" style="width: 90%;">
																			<a href="${item_obj.url}">${item_obj.title}</a>
																	</div>
															</div>
															<div class="grid-item grid-price-remove">
																	<div class="d-flex align-items-end cart-item--bottom">
																		<div class="quantity-wrapper">
																			<span class="btn-quantity-control btn-reduce-quantity drawer-reduce">–</span>
																			<input type="number" name="updates[]" id="updates_${item_obj.key}" value="${item_obj.quantity}" min="0" aria-label="Item quantity" class="input-quantity">
																			<span class="btn-quantity-control btn-add-quantity drawer-add">+</span>
																		</div>
																		<div style="display: flex;justify-content: flex-start;align-items: center;width: 45%;">
																			<span class="btn-remove-item" style="font-size:12px;"><u>Remove</u></span>
																		</div>
																		<div class="cart-price--wrapper text-right">
																			<div class="item-total">${itemPrice}</div>
																		</div>
																	</div>
																	
															</div>
														</div>
													</div>`;
				$('.cart-drawer .cart-items').prepend(itemRowHtml);
			}
		});
		$('body').addClass('slide-cart');
	};

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));